module.exports = __webpack_public_path__ + "img/49c41fc.png";